import './App.css';
import {
  Navigate,
  RouteObject,
  useRoutes
} from "react-router-dom";
import { DashboardFactory } from './presentation/sdp/dashboard/dashboard-factory';
import { DashboardFactory as DashboardScpFactory } from './presentation/scp/dashboard/dashboard-factory';
import { LoginFactory } from './presentation/login/login-factory';
import { OfficialDiarySearchFactory } from './presentation/sdp/official-diary/official-diary-search-factory';
import { OfficialDiaryDetailFactory } from './presentation/sdp/official-diary/official-diary-detail-factory';
import { SubmissionPublicationSearchFactory } from './presentation/sdp/submisson-publication/submission-publication-search-factory';
import { OfficialDiaryPublicationFactory } from './presentation/sdp/publication/official-diary-publication-factory';
import { PageNotFoundFactory } from './presentation/page-not-found-factory';
import { PageUnauthorizedFactory } from './presentation/page-unauthorized-factory';
import ApplicationAppService from './application/platform/application-app-service';
import { PurchaseSearchFactory } from './presentation/scp/purchase/purchase-search-factory';
import { PurchaseCreateEditFactory } from './presentation/scp/purchase/purchase-create-edit-factory';
import { UnidEntitySearchFactory } from './presentation/scp/unid-entity/unid-entity-search-factory';
import { UnidEntityCreateFactory } from './presentation/scp/unid-entity/unid-entity-create-factory';
import { ContractSearchFactory } from './presentation/scp/contract/contract-search-factory';
import { ContractCreateEditFactory } from './presentation/scp/contract/contract-create-edit-factory';
import { AmendmentListFactory } from './presentation/scp/contract/amendment-list-factory';
import { AmendmentCreateEditFactory } from './presentation/scp/contract/amendment-create-edit-factory';
import { PoliticalPartySearchFactory } from './presentation/sge/political-party/political-party-search-factory';
import { PoliticalPartyCreateEditFactory } from './presentation/sge/political-party/political-party-create-edit-factory';
import { ParlamentarianSearchFactory } from './presentation/sge/parlamentarian/parlamentarian-search-factory';
import { ParlamentarianCreateEditFactory } from './presentation/sge/parlamentarian/parlamentarian-create-edit-factory';
import { SupplierSearchFactory } from './presentation/sge/supplier/supplier-search-factory';
import { SupplierCreateEditFactory } from './presentation/sge/supplier/supplier-create-edit-factory';
import { AmendmentSearchFactory as SgeAmendmentSearchFactory } from './presentation/sge/amendment/amendment-search-factory';
import { AmendmentCreateEditFactory as SgeAmendmentCreateEditFactory } from './presentation/sge/amendment/amendment-create-edit-factory';
import { AmendmentDetailFactory } from './presentation/sge/amendment/detail/amendment-detail-factory';
import { BudgetUnitSearchFactory } from './presentation/sge/budget-unit/budget-unit-search-factory';
import { BudgetUnitCreateEditFactory } from './presentation/sge/budget-unit/budget-unit-create-edit-factory';
import { BudgetProgramSearchFactory } from './presentation/sge/budget-program/budget-program-search-factory';
import { BudgetProgramCreateEditFactory } from './presentation/sge/budget-program/budget-program-create-edit-factory';
import { BudgetActionSearchFactory } from './presentation/sge/budget-action/budget-action-search-factory';
import { BudgetActionCreateEditFactory } from './presentation/sge/budget-action/budget-action-create-edit-factory';
import { DashboardFactory as SgeDashboardFactory } from './presentation/sge/dashboard/dashboard-factory';
import { PublicPortalFactory } from './presentation/public/public-portal-factory';
import { PublicDashboardFactory } from './presentation/public/sge/dashboard/public-dashboard-factory';
import { PublicAmendmentSearchFactory } from './presentation/public/sge/amendment/search/public-amendment-search-factory';
import { PublicAmendmentDetailFactory } from './presentation/public/sge/amendment/detail/public-amendment-detail-factory';

const applicationData = ApplicationAppService.getApplicationData();

const ProtectedRoute = ({ children }: { children: any }) => {
  // Verifica autenticação dinamicamente a cada render
  const authorizationData = ApplicationAppService.getAuthenticationData();

  if (!authorizationData) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

const routesSdp = (): RouteObject[] => {
  var routes: RouteObject[] = [
    {
      path: "/dashboard",
      element: (
        <ProtectedRoute>
          <DashboardFactory />
        </ProtectedRoute>
      )
    },
    {
      path: "/remessas-publicacao",
      element: (
        <ProtectedRoute>
          <SubmissionPublicationSearchFactory />
        </ProtectedRoute>
      )
    },
    {
      path: "/remessas-publicacao/detalhes/:submissionPublicationId",
      element: (
        <ProtectedRoute>
          <SubmissionPublicationSearchFactory />
        </ProtectedRoute>
      )
    },
    {
      path: "/diario-oficial",
      element: (
        <ProtectedRoute>
          <OfficialDiarySearchFactory />
        </ProtectedRoute>
      )
    },
    {
      path: "/diario-oficial/detalhes/:officialDailyId",
      element: (
        <ProtectedRoute>
          <OfficialDiaryDetailFactory />
        </ProtectedRoute>
      )
    },
    {
      path: "/diario-oficial/publicar/:submissionPublicationId?",
      element: (
        <ProtectedRoute>
          <OfficialDiaryPublicationFactory />
        </ProtectedRoute>
      )
    },
  ];
  return routes;
}

const routesScp = (): RouteObject[] => {

  var routes: RouteObject[] = [
    {
      path: "/dashboard",
      element: (
        <ProtectedRoute>
          <DashboardScpFactory />
        </ProtectedRoute>
      )
    },
    {
      path: "/compras-licitacoes",
      element: (
        <ProtectedRoute>
          <PurchaseSearchFactory />
        </ProtectedRoute>
      )
    },
    {
      path: "/compras-licitacoes/publicar/:purchaseId?",
      element: (
        <ProtectedRoute>
          <PurchaseCreateEditFactory />
        </ProtectedRoute>
      )
    },
    {
      path: "/unidades-entidade",
      element: (
        <ProtectedRoute>
          <UnidEntitySearchFactory />
        </ProtectedRoute>
      )
    },
    {
      path: "/unidades-entidade/adicionar",
      element: (
        <ProtectedRoute>
          <UnidEntityCreateFactory />
        </ProtectedRoute>
      )
    },
    {
      path: "/contratos",
      element: (
        <ProtectedRoute>
          <ContractSearchFactory />
        </ProtectedRoute>
      )
    },
    {
      path: "/contratos/:contractId/aditivos",
      element: (
        <ProtectedRoute>
          <AmendmentListFactory />
        </ProtectedRoute>
      )
    },
    {
      path: "/contratos/:contractId/aditivos/publicar/:sequentialId?",
      element: (
        <ProtectedRoute>
          <AmendmentCreateEditFactory />
        </ProtectedRoute>
      )
    },
    {
      path: "/contratos/publicar/:contractId?",
      element: (
        <ProtectedRoute>
          <ContractCreateEditFactory />
        </ProtectedRoute>
      )
    },
  ];
  return routes;

}

const routesSge = (): RouteObject[] => {
  return [
    { path: '/dashboard', element: <ProtectedRoute><SgeDashboardFactory /></ProtectedRoute> },
    { path: '/partidos-politicos', element: <ProtectedRoute><PoliticalPartySearchFactory /></ProtectedRoute> },
    { path: '/partidos-politicos/cadastrar', element: <ProtectedRoute><PoliticalPartyCreateEditFactory /></ProtectedRoute> },
    { path: '/partidos-politicos/editar/:partyId', element: <ProtectedRoute><PoliticalPartyCreateEditFactory /></ProtectedRoute> },
    { path: '/parlamentares', element: <ProtectedRoute><ParlamentarianSearchFactory /></ProtectedRoute> },
    { path: '/parlamentares/cadastrar', element: <ProtectedRoute><ParlamentarianCreateEditFactory /></ProtectedRoute> },
    { path: '/parlamentares/editar/:parlamentarianId', element: <ProtectedRoute><ParlamentarianCreateEditFactory /></ProtectedRoute> },
    { path: '/fornecedores', element: <ProtectedRoute><SupplierSearchFactory /></ProtectedRoute> },
    { path: '/fornecedores/cadastrar', element: <ProtectedRoute><SupplierCreateEditFactory /></ProtectedRoute> },
    { path: '/fornecedores/editar/:supplierId', element: <ProtectedRoute><SupplierCreateEditFactory /></ProtectedRoute> },
    { path: '/emendas', element: <ProtectedRoute><SgeAmendmentSearchFactory /></ProtectedRoute> },
    { path: '/emendas/cadastrar', element: <ProtectedRoute><SgeAmendmentCreateEditFactory /></ProtectedRoute> },
    { path: '/emendas/editar/:amendmentId', element: <ProtectedRoute><SgeAmendmentCreateEditFactory /></ProtectedRoute> },
    { path: '/emendas/:amendmentId', element: <ProtectedRoute><AmendmentDetailFactory /></ProtectedRoute> },
    { path: '/unidades-orcamentarias', element: <ProtectedRoute><BudgetUnitSearchFactory /></ProtectedRoute> },
    { path: '/unidades-orcamentarias/cadastrar', element: <ProtectedRoute><BudgetUnitCreateEditFactory /></ProtectedRoute> },
    { path: '/unidades-orcamentarias/editar/:budgetUnitId', element: <ProtectedRoute><BudgetUnitCreateEditFactory /></ProtectedRoute> },
    { path: '/programas-orcamentarios', element: <ProtectedRoute><BudgetProgramSearchFactory /></ProtectedRoute> },
    { path: '/programas-orcamentarios/cadastrar', element: <ProtectedRoute><BudgetProgramCreateEditFactory /></ProtectedRoute> },
    { path: '/programas-orcamentarios/editar/:budgetProgramId', element: <ProtectedRoute><BudgetProgramCreateEditFactory /></ProtectedRoute> },
    { path: '/acoes-orcamentarias', element: <ProtectedRoute><BudgetActionSearchFactory /></ProtectedRoute> },
    { path: '/acoes-orcamentarias/cadastrar', element: <ProtectedRoute><BudgetActionCreateEditFactory /></ProtectedRoute> },
    { path: '/acoes-orcamentarias/editar/:budgetActionId', element: <ProtectedRoute><BudgetActionCreateEditFactory /></ProtectedRoute> },
    {
      path: '/:uf/:citySlug/transparencia',
      element: <PublicPortalFactory />,
      children: [
        { index: true, element: <PublicDashboardFactory /> },
        { path: 'emendas', element: <PublicAmendmentSearchFactory /> },
        { path: 'emendas/:amendmentId', element: <PublicAmendmentDetailFactory /> },
      ],
    },
  ];
};

const defaultRoutes = (): RouteObject[] => {
  var routes: RouteObject[] = [
    {
      path: "*",
      element: <PageNotFoundFactory />
    },
    {
      path: "/",
      element: <LoginFactory />
    },
    {
      path: "/unauthorized",
      element: <PageUnauthorizedFactory />
    },
  ];

  return routes;
}

const createRoutesModules = (): RouteObject[] => {
  var routes = defaultRoutes();
  if (applicationData.moduleId === 1) {
    routes.push(...routesSdp());
  } else if (applicationData.moduleId === 2) {
    routes.push(...routesScp());
  } else if (applicationData.moduleId === 3) {
    routes.push(...routesSge());
  }
  return routes;
}

const App = () => {
  let routes = useRoutes(
    createRoutesModules()
  );
  return routes;
}

export default App;
